<template>
  <v-footer padless class="tech-footer-wrapper">
    <div class="circuit-overlay"></div>
    <div class="scanlines"></div>
    <div class="neon-top-border"></div>

    <v-container class="content-relative py-8 py-md-12">
      <v-row justify="center">
        
        <v-col cols="12" sm="6" md="4" class="mb-6 mb-md-0">
          <div class="footer-block pa-4 h-100">
            <h4 class="text-h5 font-weight-black cyan--text mb-6 mb-md-8 d-flex align-center justify-center justify-md-start neon-text tracking-wide">
              <v-icon left color="cyan">mdi-link-variant</v-icon>
              ENLACES_DE_RED
            </h4>
            
            <v-list dense color="transparent" dark class="pa-0 custom-list-mobile">
              <v-list-item v-for="(item, i) in menuItems" :key="i" class="px-0 hover-item mb-2">
                <v-list-item-icon class="mr-3 d-none d-sm-flex">
                  <v-icon color="grey darken-1">mdi-chevron-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <router-link :to="item.to" class="footer-link text-center text-md-left">{{ item.text }}</router-link>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" class="mb-6 mb-md-0 order-md-2 order-3">
          <div class="footer-block pa-4 h-100 d-flex flex-column align-center justify-center border-responsive">
            <v-icon size="60" md="80" color="rgba(0, 229, 255, 0.2)" class="mb-4 spin-slow">mdi-radar</v-icon>
            
            <div class="text-subtitle-2 text-md-subtitle-1 grey--text text--lighten-1 mono-font mb-6 text-center">
              >> ESTADO DE CONEXIÓN: <br class="d-md-none">
              <span class="green--text text--accent-3 font-weight-bold">ESTABLE</span>
            </div>

            <div class="d-flex justify-center social-buttons flex-wrap">
              <v-btn v-for="social in socials" :key="social.icon" icon large color="cyan darken-1" class="mx-1 mx-md-2 glow-icon" :href="social.link" target="_blank">
                <v-icon size="28">mdi-{{ social.icon }}</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4" class="order-md-3 order-2">
          <div class="footer-block pa-4 h-100">
            <h4 class="text-h5 font-weight-black cyan--text mb-6 mb-md-8 d-flex align-center justify-center justify-md-start neon-text tracking-wide">
              <v-icon left color="cyan">mdi-console</v-icon>
              CANAL_DIRECTO
            </h4>

            <v-list two-line color="transparent" dark class="pa-0 contact-list">
              <v-list-item class="px-0 mb-4 contact-item">
                <v-list-item-avatar class="neon-border-circle d-none d-sm-flex" size="45">
                  <v-icon color="cyan accent-3">mdi-map-marker-radius</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="text-center text-md-left">
                  <v-list-item-title class="cyan--text text--lighten-3 subtitle-2 font-weight-bold mb-1">UBICACIÓN FÍSICA</v-list-item-title>
                  <v-list-item-subtitle class="white--text text-body-2">
                    UNI, Recinto Simón Bolívar.<br>Edificio Rigoberto López
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item class="px-0 mb-4 contact-item">
                <v-list-item-avatar class="neon-border-circle d-none d-sm-flex" size="45">
                  <v-icon color="cyan accent-3">mdi-email-lock</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="text-center text-md-left">
                  <v-list-item-title class="cyan--text text--lighten-3 subtitle-2 font-weight-bold mb-1">CORREO ELECTRÓNICO</v-list-item-title>
                  <a href="mailto:info@nic.uni.edu.ni" class="tech-link text-body-1">info@nic.uni.edu.ni</a>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-col>

      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "TechFooter",
  data: () => ({
    menuItems: [
      { text: 'Log del Sistema (Historia)', to: '/Historia' },
      { text: 'Protocolos Éticos (Valores)', to: '/Valores' },
      { text: 'Escaneo de Disponibilidad', to: '/BuscarDominio' },
      { text: 'Base de Conocimiento (FAQ)', to: '/Faqs' },
    ],
    socials: [
      { icon: 'facebook', link: '#' },
      { icon: 'twitter', link: '#' },
      { icon: 'instagram', link: '#' },
      { icon: 'youtube', link: '#' },
    ]
  })
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&family=Montserrat:wght@400;700&display=swap');

.tech-footer-wrapper {
  background-color: #080c14 !important;
  font-family: 'Montserrat', sans-serif;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(0, 229, 255, 0.2);
}

.mono-font { font-family: 'Fira Code', monospace !important; }
.tracking-wide { letter-spacing: 1px; }

/* Capas de fondo */
.circuit-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: radial-gradient(circle at 50% 50%, rgba(0, 255, 255, 0.03) 0%, transparent 70%);
  z-index: 0;
}

.scanlines {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 50%, rgba(0,0,0,0.1) 50%);
  background-size: 100% 4px;
  pointer-events: none;
  z-index: 1;
}

.neon-top-border {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 2px;
  background: linear-gradient(90deg, transparent, #00E5FF, transparent);
  box-shadow: 0 0 15px #00E5FF;
}

.content-relative { position: relative; z-index: 3; }

/* Enlaces y Tipografía */
.neon-text { text-shadow: 0 0 10px rgba(0, 229, 255, 0.5); }

.footer-link {
  color: #B0BEC5;
  text-decoration: none;
  transition: all 0.3s;
  font-family: 'Fira Code', monospace;
  font-size: 1rem !important;
  display: block;
}

.footer-link:hover {
  color: #00E5FF;
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.8);
  transform: translateX(5px);
}

.tech-link {
  color: #00E5FF;
  text-decoration: none;
  border-bottom: 1px dashed rgba(0, 229, 255, 0.3);
}

/* Bordes Responsivos */
.border-responsive {
  border-left: 1px solid rgba(0, 229, 255, 0.1);
  border-right: 1px solid rgba(0, 229, 255, 0.1);
}

.neon-border-circle {
  border: 1.5px solid rgba(0, 229, 255, 0.4);
  background: rgba(0, 229, 255, 0.05);
}

.glow-icon:hover {
  color: #00E5FF !important;
  filter: drop-shadow(0 0 8px cyan);
  transform: translateY(-3px);
}

/* Animaciones */
.spin-slow { animation: spin 15s linear infinite; }
@keyframes spin { 100% { transform: rotate(360deg); } }

/* Media Queries para Mobile Refinement */
@media (max-width: 960px) {
  .border-responsive {
    border: none;
    border-top: 1px solid rgba(0, 229, 255, 0.1);
    border-bottom: 1px solid rgba(0, 229, 255, 0.1);
    padding: 40px 0;
    margin: 20px 0;
  }
  
  .footer-link:hover {
    transform: none; /* Evitar saltos laterales en móvil */
  }

  .contact-item {
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .text-h5 { font-size: 1.25rem !important; }
  .footer-link { font-size: 0.9rem !important; }
}
</style>